import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-buy-theme" }
const _hoisted_2 = { class: "modal-buy-theme__text" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("? ")
const _hoisted_4 = { class: "modal-buy-theme__checkbox" }
const _hoisted_5 = { class: "modal-buy-theme__checkbox-content" }
const _hoisted_6 = {
  href: "http://www.tray.com.br/contrato/lojadetema",
  target: "_blank",
  class: "modal-buy-theme__checkbox-content--link"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    "class-style": "modal-height-buy-theme",
    title: _ctx.title,
    "label-button": _ctx.$t('components.modals.button.continue'),
    "is-disabled": _ctx.isDisabled,
    "type-button": "continue",
    onContinue: _ctx.themeBuy,
    onCancel: _ctx.resetCheckBox
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createVNode(_component_Alert, {
          "input-fields": {
          label: _ctx.$t('components.modals.titles.attention') + '!',
          description: _ctx.$t('components.alert.description-buy-theme'),
        },
          icon: true
        }, null, 8, ["input-fields"]),
        _createElementVNode("span", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$t('components.modals.buy-theme.title')) + " ", 1),
          _createElementVNode("strong", null, _toDisplayString(_ctx.theme.name), 1),
          _hoisted_3
        ]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkbox) = $event)),
            type: "checkbox",
            class: "modal-buy-theme__checkbox--input"
          }, null, 512), [
            [_vModelCheckbox, _ctx.checkbox]
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", null, [
              _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.$t('components.modals.buy-theme.terms-of-acceptance')), 1)
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.modals.buy-theme.description')), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "label-button", "is-disabled", "onContinue", "onCancel"]))
}